export default __webpack_public_path__ + "static/media/risoto-alho-poro.07f8ef1d.jpg";